// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setUrgentCareCount,
  setUrgentCareDeclineReasons,
  setUrgentCareUsers,
  setUrgentCareUsersOnDuty,
  setWaitingRoomList,
  setWaitingRoomLoading
} from 'src/store/modules/actions/urgentCare'

const initialState = {
  waitingRoomList: [],
  waitingRoomLoading: false,
  urgentCareCount: 0,
  urgentCareUsersList: [],
  urgentCareDeclineReasons: [],
  urgentCareUsersOnDuty: []
}

export default handleActions(
  {
    [setWaitingRoomList](state, { payload: waitingRoomList }) {
      return {
        ...state,
        waitingRoomList
      }
    },
    [setWaitingRoomLoading](state, { payload: waitingRoomLoading }) {
      return {
        ...state,
        waitingRoomLoading
      }
    },
    [setUrgentCareCount](state, { payload: urgentCareCount }) {
      return {
        ...state,
        urgentCareCount
      }
    },
    [setUrgentCareUsers](state, { payload: urgentCareUsersList }) {
      return {
        ...state,
        urgentCareUsersList
      }
    },
    [setUrgentCareUsersOnDuty](state, { payload: urgentCareUsersOnDuty }) {
      return {
        ...state,
        urgentCareUsersOnDuty
      }
    },
    [setUrgentCareDeclineReasons](
      state,
      { payload: urgentCareDeclineReasons }
    ) {
      return {
        ...state,
        urgentCareDeclineReasons
      }
    }
  },
  initialState
)
